import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import WhyChooseUs from "./components/WhyChooseUs";
import FAQ from "./components/FAQ";
import BlogTeaser from "./components/BlogTeaser";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BlogIndex from "./components/BlogIndex";
import BlogPost from "./components/BlogPost";

const SITE_URL = "https://wrapalotspecialtyfilmz.com";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Car Wrap Installation Sacramento, CA | WrapAlot Specialty Filmz</title>
        <meta
          name="description"
          content="Top-rated car wrap installation near me in Sacramento, CA. Premium vehicle wraps, color changes, fleet graphics, paint protection film and window tint. Certified installers, 5-year warranty, free quote. Call 916-336-7865."
        />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:type" content="business.business" />
        <meta
          property="og:title"
          content="Car Wrap Installation Sacramento, CA | WrapAlot Specialty Filmz"
        />
        <meta
          property="og:description"
          content="Sacramento's trusted car wrap installation shop. Premium vehicle wraps, color changes, fleet graphics, paint protection film & window tint. 5-year warranty. Free quote: 916-336-7865."
        />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta
          name="twitter:title"
          content="Car Wrap Installation Sacramento, CA | WrapAlot Specialty Filmz"
        />
        <meta
          name="twitter:description"
          content="Premium car wraps, color changes, paint protection film & window tint in Sacramento, CA. Certified installers · 5-year warranty · Free quote."
        />
      </Helmet>
      <Hero />
      <Services />
      <Portfolio />
      <WhyChooseUs />
      <FAQ />
      <BlogTeaser />
      <Contact />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App bg-slate-900 min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
